<td class="name-col">
  <div class="cell-content p-0">
    <div class="total-labels">
      <div class="sub-row-item">
        Grand Total
      </div>
      <div class="sub-row-item" *ngIf="performanceMode">
        Return on Marketing Plan
      </div>
    </div>
    <div class="performance-cell">
    </div>
  </div>
</td>

<td *ngFor="let timeframe of timeframes; trackBy: identifyTimeframe"
    class="timeframe-col grand-total"
    [ngClass]="{
      'locked': timeframe.locked,
      'is-hidden': !budgetMode || !timeframe.isVisible
    }"
>
  <div class="cell-content" *ngIf="grandTotalBudget" [ngClass]="{'filtered-out-cell': timeframeSelectedFilters.length && !timeframeSelectedFilters.includes(timeframe?.id)}">
    <div class="sub-columns">
      <ng-container *ngFor="let column of budgetColumnsVisibility[budgetColumns[0].id] ? budgetColumns : budgetColumns.slice(1); trackBy: identifyColumn">
        <div *ngIf="budgetColumnsVisibility[column.id] && column.id !== budgetColumnName.Forecast" class="default-value">
          {{ (grandTotalBudget[timeframe.id] && grandTotalBudget[timeframe.id][column.id]) | absoluteNumber }}
        </div>
        <div *ngIf="budgetColumnsVisibility[column.id] && column.id === budgetColumnName.Forecast" class="default-value forecast-column-total">
         <!-- For forecast summary total per timeframe allocation column -->
          {{ (grandTotalBudget[timeframe.id] && grandTotalBudget[timeframe.id][column.id]) | absoluteNumber }}
        </div>
      </ng-container>
    </div>
  </div>
</td>

<td *ngIf="performanceMode && grandTotalPerformance" class="performance-column" @slideFromRightColumn>
  <div class="cell-content sub-columns">
    <div class="segment-breakdown" *ngFor="let column of performanceColumns">
      <div class="sub-row-item default-value">
        {{ grandTotalPerformance[column.id][0] | absoluteNumber: '-' }}
      </div>
      <div class="sub-row-item default-value">
        {{ grandTotalPerformance[column.id][1] | absoluteNumber: '-' }}
      </div>
    </div>
  </div>
</td>

<td class="total-column" *ngIf="totalsSidebarState !== sidebarState.Hidden" @slideFromRightColumn>
  <div class="cell-content sub-columns">
    <ng-container *ngFor="let column of budgetColumnsVisibility[budgetColumns[0].id] ? budgetColumns : budgetColumns.slice(1); trackBy: identifyColumn">
      <div *ngIf="column.id === budgetColumnName.Budget || (budgetColumnsVisibility[column.id] && column.id !== budgetColumnName.Forecast && totalsSidebarState === sidebarState.FullWidth)"
           class="sub-row-item default-value">
        {{ grandTotalForActiveTimeframes[column.id] | absoluteNumber }}
      </div>
      <div *ngIf="budgetColumnsVisibility[column.id] && column.id === budgetColumnName.Forecast" class="default-value forecast-column-total">
        <!-- For forecast summary total -->
        {{ grandTotalForActiveTimeframes[column.id] | absoluteNumber }} 
      </div>
    </ng-container>
  </div>
</td>
